import React, { useState } from "react";
import styled from "styled-components";
import { Form, Row, Col } from "antd";
import { useLocation } from "react-router-dom";
import { Input, DatePicker, Section, Grid, Button, Typography, Loading } from "../../core";
import { MixStyle } from "../../styles";
import { registerSizerBill } from "../../helper/utils/api/sizer";
import { getCompanyId } from "../../helper/utils/companyId";
import moment from "moment";

const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 24 },
};

const StyledForm = styled(Form)`
  label {
    ${MixStyle.Label};
  }
`;

const SizerInvoice = () => {
  const location = useLocation();
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");

  const program = location.state?.program || {};
  const sizerId = location.state?.sizerId;

  const onFinish = async (values) => {
    setIsLoading(true);
    setMessage("");
    try {
      const companyId = getCompanyId();
      await registerSizerBill({
        ...values,
        bill_date: values.bill_date.format("YYYY-MM-DD"),
        company_id: companyId,
        sizer_id: sizerId,
        total_amount: program.ammount || program.amount || 0,
        program_id: program._id || program.add_program_id,
      });
      setMessage("Bill saved successfully");
      form.resetFields();
    } catch (error) {
      setMessage(error?.response?.data?.message || "Failed to save bill");
    }
    setIsLoading(false);
  };

  return (
    <Grid>
      {isLoading ? <Loading /> : null}
      <Section padding="20px">
        <StyledForm
          form={form}
          {...layout}
          initialValues={{ bill_date: moment() }}
          onFinish={onFinish}
        >
          <Row gutter={{ xs: 0, sm: 48, md: 48, lg: 48 }}>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Bill No"
                name="bill_no"
                rules={[{ required: true, message: "Please enter bill no" }]}
              >
                <Input placeholder="Bill No" />
              </Form.Item>
            </Col>
            <Col md={12} sm={18} xs={24}>
              <Form.Item
                label="Bill Date"
                name="bill_date"
                rules={[{ required: true, message: "Please set bill date" }]}
              >
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            {message ? (
              <Col span={24}>
                <Typography text={message} as="p" />
              </Col>
            ) : null}
            <Col span={24}>
              <Button bg="#404E67" type="primary" htmlType="submit">
                <Typography
                  text="Save Bill"
                  as="h5"
                  noMargin
                  weight="bold"
                  align="center"
                  color="white"
                />
              </Button>
            </Col>
          </Row>
        </StyledForm>
      </Section>
    </Grid>
  );
};

export default SizerInvoice;
